export default async (e) => {
  e.preventDefault();
  try {
    await caches
      .keys()
      .then((cachesNames) => {
        if (document.defaultView) {
          console.log(
            "Delete " + document.defaultView.location.origin + " caches"
          );
        }
        return Promise.all(
          cachesNames.map(function (cacheName) {
            return caches.delete(cacheName).then(function () {
              console.log("Cache with name " + cacheName + " is deleted");
            });
          })
        );
      })
      .then(function () {
        if (document.defaultView) {
          console.log(
            "All " +
              document.defaultView.location.origin +
              " caches are deleted"
          );
        }
      });
  } catch (error) {}

  window.location.reload();
};
